module.exports = __webpack_public_path__ + "img/thumb_18.7a803e3e.jpg";